import application from './application'
import campaign from './campaign'

export default {
  application,
  campaign,
}
